import { store } from '.';

enum OperatingPhase {
  ALL = 'all',
  STABLE = 'stable',
  TRANSITION = 'transition',
}

const setOperatingPhase = (operatingPhase: OperatingPhase) => {
  store.operatingPhase = operatingPhase;
};

export { OperatingPhase, setOperatingPhase };
